import { render, staticRenderFns } from "./BasicInfoStepper.vue?vue&type=template&id=01859b58&scoped=true"
import script from "./BasicInfoStepper.vue?vue&type=script&lang=js"
export * from "./BasicInfoStepper.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoStepper.vue?vue&type=style&index=0&id=01859b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01859b58",
  null
  
)

export default component.exports